<template>


  <div class="select-themes-view">
    <div>
      <div class="tabs">
        <ul>
          <li v-for="tab of tabs" :class="activeTabId === tab.id ? 'is-active' :'disabled'">
            <div>{{ tab.title }}</div>
          </li>
        </ul>
      </div>


      <div class="tabs-content">

        <template v-if="activeTabId === 'start-tab'">

          <div class="tabs-content-sub-header">
            <div>{{ $t('start-tab-sub-header') }}</div>
          </div>

          <div class="tabs-content-description" v-html="$t('start-tab-description')"></div>

          <div class="start-tab-info-box">
            <div class="start-tab-info-box-left-bar">
              <i class="fal fa-info-circle fa-2x"></i>
            </div>
            <div class="start-tab-info-box-content" v-html="$t('start-tab-info-box-content')"></div>
          </div>
          <span class="start-tab-pre-privacy-box-text">{{ $t('start-tab-pre-privacy-box-text') }}</span>

          <div class="ticket-wrapper">
            <span class="ticket-id-header">{{ $t('ticket_id') }}</span>
            <div class="ticket-id-container">

              <div class="ticket-part-container">
                <CustomInputText v-model:value="ticketId1"
                                 v-bind:autocomplete="'off'"
                                 v-bind:pattern="'[a-zA-Z0-9]'"
                                 v-bind:id="'ticket-part-1'"
                                 max-length=4 v-on:change="onTicketPart1Changed"
                                 v-bind:required="true"></CustomInputText>
              </div>
              <div class="ticket-part-container">
                <CustomInputText v-model:value="ticketId2"
                                 v-bind:autocomplete="'off'"
                                 v-bind:pattern="'[a-zA-Z0-9]'"
                                 v-bind:id="'ticket-part-2'"
                                 max-length=4 v-on:change="onTicketPart2Changed"
                                 v-bind:required="true"></CustomInputText>
              </div>
              <div class="ticket-part-container">
                <CustomInputText v-model:value="ticketId3"
                                 v-bind:autocomplete="'off'"
                                 v-bind:pattern="'[a-zA-Z0-9]'"
                                 v-bind:id="'ticket-part-3'"
                                 max-length=3 v-on:change="onTicketPart3Changed"
                                 v-bind:required="true"></CustomInputText>
              </div>
              <div class="ticket-part-container">
                <CustomInputText v-model:value="ticketId4"
                                 v-bind:autocomplete="'off'"
                                 v-bind:pattern="'[a-zA-Z0-9]'"
                                 v-bind:id="'ticket-part-4'"
                                 max-length=3
                                 v-bind:required="true"></CustomInputText>
              </div>
            </div>

          </div>

          <div class="start-tab-privacy-box">
            <span v-html="$t('start-tab-privacy-box-text')"></span>

            <custom-check-box v-bind:checkbox-text="$t('matchmaking-privacy')"
                              v-model:value="acceptTermsOfUse"></custom-check-box>

            <custom-button :width="250" :on-clicked="login"
                           :icon="'fal fa-file-signature fa-2x'">
              {{ $t('start-tab-confirm-privacy-button-text') }}
            </custom-button>
          </div>
        </template>
        <template v-if="activeTabId === 'profile-create-tab'">
          <create-profile :on-create-clicked="onProfileCreated" ref="createProfile"></create-profile>
        </template>
      </div>
    </div>
  </div>


</template>

<script>
import themes from "../themes/themes-helper";
import CustomCheckBox from "./inputs/CustomCheckBox";
import {isDefined, scrollToElement} from "../utils";
import CreateProfile from "./CreateProfile";
import CustomButton from "./inputs/CustomButton";
import i18n from "../i18n";
import CustomInputText from "@/components/inputs/CustomInputText.vue";

const {t} = i18n.global;
export default {
  name: "LoginView",
  components: {CustomInputText, CustomCheckBox, CreateProfile, CustomButton},
  props: {
    isDuringRegistration: {
      default: false,
      required: false
    }
  },
  data() {
    return {
      acceptTermsOfUse: false,
      activeTabId: 'start-tab',
      ticketId1: '',
      ticketId2: '',
      ticketId3: '',
      ticketId4: '',
      tabs: []
    }
  },
  beforeMount() {
    addEventListener("paste", event => this.handlePasteEvent()(event));
    const tabs = [{
      id: 'start-tab',
      title: t('start-tab-header')
    }];
    if (this.$createProfileEnabled) {
      tabs.push({
        id: 'profile-create-tab',
        title: t('profile-create-tab-header')
      });
    }
    themes.reloadThemesTab(this.isDuringRegistration, undefined)
    tabs.push(...themes.getThemeSelectTabs());
    this.tabs = tabs;
  },
  unmounted() {
    if (this.isDuringRegistration) {
      themes.reloadThemesTab(false, undefined);
    }
    removeEventListener("paste", this.handlePasteEvent());
  },
  methods: {
    getNextEmptyTicketInput() {
      if (isDefined(this.ticketId2) && this.ticketId2.length < 4) {
        return 'ticket-part-2'
      }
      if (isDefined(this.ticketId3) && this.ticketId3.length < 3) {
        return 'ticket-part-3'
      }
      if (isDefined(this.ticketId4) && this.ticketId4.length < 3) {
        return 'ticket-part-4'
      }
      return undefined
    },
    onTicketPart1Changed(data) {
      if (isDefined(data) && (typeof data === 'string' || data instanceof String) && data.trim().length === 4) {
        const nextEmptyTicketInput = this.getNextEmptyTicketInput();
        if (isDefined(nextEmptyTicketInput)) {
          document.getElementById(nextEmptyTicketInput).focus();
        }
      }
    },
    onTicketPart2Changed(data) {
      if (isDefined(data) && (typeof data === 'string' || data instanceof String) && data.trim().length === 4) {
        const nextEmptyTicketInput = this.getNextEmptyTicketInput();
        if (isDefined(nextEmptyTicketInput)) {
          document.getElementById(nextEmptyTicketInput).focus();
        }
      }
    },
    onTicketPart3Changed(data) {
      if (isDefined(data) && (typeof data === 'string' || data instanceof String) && data.trim().length === 3) {
        const nextEmptyTicketInput = this.getNextEmptyTicketInput();
        if (isDefined(nextEmptyTicketInput)) {
          document.getElementById(nextEmptyTicketInput).focus();
        }
      }
    },
    handlePasteEvent(event) {
      return function (event) {
        if (isDefined(event.target.id) && !event.target.id.startsWith('ticket-part-')) {
          return;
        }
        let data = event.clipboardData.getData("text");
        if (isDefined(data) && data.length > 0) {
          data = data.replace(/\s/g, "");
          data = data.replace(/[^a-zA-Z0-9]/g, "");
          if (data.length >= 4) {
            this.ticketId1 = data.substring(0, 4);
          }
          if (data.length >= 8) {
            this.ticketId2 = data.substring(4, 8);
          }
          if (data.length >= 11) {
            this.ticketId3 = data.substring(8, 11);
          }
          if (data.length >= 14) {
            this.ticketId4 = data.substring(11, 14);
          }
        }
      }.bind(this);

    },
    onProfileCreated(userData) {
      this.$emit("submit", userData);
    },
    login() {
      if (this.acceptTermsOfUse) {
        if (this.$createProfileEnabled) {
          this.activeTabId = 'profile-create-tab';
          this.$nextTick(() => {
            scrollToElement(this.$refs.createProfile.$el);
          })
        } else {
          const ticketId = `${this.ticketId1}${this.ticketId2}${this.ticketId3}${this.ticketId4}`.toUpperCase();
          if (ticketId.trim().length === 0) {
            this.$toasted.error(this.$t('missing-ticket-id').toString(), {
              timeout: 2000,
              position: "bottom-right"
            });
            return;
          }

          if (ticketId.trim().length < 14) {
            this.$toasted.error(this.$t('to-short-ticket-id').toString(), {
              timeout: 2000,
              position: "bottom-right"
            });
            return;
          }


          this.$emit("submit", {
            ticket_id: ticketId
          });
        }
      } else {
        this.$toasted.info(this.$t('policy-warning').toString(), {
          timeout: 2000,
          position: "bottom-right"
        });
      }
    },
  }
}
</script>

<style lang="less">

.select-themes-view {
  max-width: 1300px;
}

.start-tab-info-box {
  width: 100%;
  background-color: var(--start-tab-info-box-color);
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;

  &-left-bar {
    width: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    background-color: var(--start-tab-info-color);

    > i {
      color: #FFFFFF;
    }
  }

  &-content {
    margin: 10px 20px 10px 0px;

    > ul {
      list-style: disc;
      margin-block-start: 1em !important;
      margin-block-end: 1em !important;
      padding-inline-start: 40px !important;
    }

    display: flex;
    flex-direction: column;
    text-align: left;
    font-weight: normal;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    width: 90%;

    > span {
      margin-left: 10px;
    }
  }

}

.start-tab-privacy-box {
  width: 100%;

  background-color: var(--primary-color);
  color: #FFFFFF;
  margin-top: 30px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  font-weight: normal;

  > span {
    padding-bottom: 50px;
  }

  .custom-button {
    align-self: flex-end;
    background: var(--dark-button-color) !important;

    .icon {
      background: var(--dark-button-icon-color) !important;
    }
  }

  .checkbox-wrapper {
    padding-bottom: 30px;

    .checkbox {
      border: none;
      background: #FFFFFF;
      flex-shrink: 0;
      margin-right: 10px;

      > i {
        color: #000000;
      }
    }

    .checkbox-label {
      a {
        color: #FFFFFF;
      }
    }
  }

  .fa-file-signature {
    font-size: 1.6em;
    padding-left: 5px;
  }
}


.ticket-wrapper {
  display: flex;
  flex-direction: column;

  margin-left: auto;
  margin-right: auto;


  .ticket-id-header {
    margin-top: 20px;
    text-align: left;
    font-size: 20px;
  }

  .ticket-id-container {
    display: flex;
    flex-direction: row;

    .ticket-part-container {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid var(--primary-color);
      height: 60px;
      border-radius: 12px;
      width: 70px;
      margin-right: 12px;

      > .input-wrapper {
        margin-right: 0;
        border-bottom: none !important;
        margin-bottom: 0 !important;

        > label {
          display: none;
        }

        > input {
          text-align: center;
          margin-top: 0 !important;
          text-transform: uppercase;
        }
      }
    }
  }
}

</style>
